import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { HttpClient } from '@angular/common/http';
import { SignatureDocument, SignatureDocumentUsers } from '../model/signatureDocumentUsers';

@Injectable({
  providedIn: 'root'
})
export class SignatureDocumentUsersService {

  baseUrl = `${environment.signatureUrl }/signatureDocumentUsers`;
  constructor(private http: HttpClient) { }

  findAllUsersSignature(): Observable<any> {
    const url = `${this.baseUrl}/usersSignature`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
          
  }

  findByUsernameIdDocumentAndIdType(username: string, idDocument: number, idType: number): Observable<any> {
    const url = `${this.baseUrl}/${username}/${idDocument}/${idType}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
          
  }
}
